<template>
  <div id='share'>
  <div class="mt-5" v-if="app.message">{{ app.message }}</div>
  <div class="alert alert-danger" v-if="isLive">ライブ配信中</div>
  <div class="container mt-5" v-if="game.gameInfo.linkShareFlg || game.gameInfo.publicShareFlg">
    <div class="row">
      <div class="col-12">
        <counter :info="info" />
      </div>
    </div>
    <div class="container mw-600">
      <div v-if="game.gameInfo.memoFlg == 1" class="mb-4 mt-4">
        <b-form-textarea id="textarea" v-model="game.gameInfo.memo"
          placeholder="メモ" rows="3" max-rows="100" :disabled="true" />
      </div>
    </div>
    <graph :game="game" />
    <div class="row mt-5">
      <div class="col-12 text-center">
        <b-button variant="outline-secondary" class="btn" @click="$router.push('/detail_data');">
          詳細データ
        </b-button>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/firestore';
import counter from '@/components/molecules/Counter';
import Graph from '@/components/organisms/Graph';
import func from '@/lib/func';

export default {
  name: 'share',
  components: {
    counter,
    Graph,
  },
  data() {
    return {
      manualInput1: '',
      manualInput2: '',
      options: [
        { value: 1, text: '1ゲーム' },
        { value: 2, text: '3ゲーム（2ゲーム先取）' },
        { value: 3, text: '5ゲーム（3ゲーム先取）' },
        { value: 4, text: '7ゲーム（5ゲーム先取）' },
      ],
      manualName: '',
      submitButton: false,
      isLive: false,
      intervalId: undefined,
      unsbscribe1: undefined,
    };
  },
  destroyed() {
    clearInterval(this.intervalId);
    if (this.unsbscribe1) {
      this.unsbscribe1();
    }
  },
  mounted() {
    // データの変更をリッスンする処理
    this.reset({ isProMode: false });
    this.setMessage('');
    this.setDocId(this.$route.params.id);
    this.intervalId = setInterval(() => {
      this.setIsLive();
    }, 5000);
  },
  computed: {
    info() {
      let info = { p1: 0, p2: 0, s1: 0, s2: 0, nextSv: 0 };
      for (let i = 0; i < this.game.points.length; i++) {
        info = func.nextPoint(info, this.game.points[i]);
      }
      return info;
    },
    ...mapGetters([
      'game',
      'app',
    ]),
  },
  methods: {
    ...mapActions([
      'setMessage',
      'reset',
      'storeIsLoading',
      'setGameDataOption',
      'setGameData',
    ]),
    setDocId(docId) {
      // サーバー側の変更を待機してstoreに反映する処理
      const db = firebase.firestore();
      this.storeIsLoading(true);
      this.unsbscribe1 = db.collection('games').doc(docId)
        .onSnapshot((doc) => {
          if (doc.exists) {
            // サブコレクションの取得
            if (doc.data().isProMode) {
              db.collection('games').doc(docId).collection('option').doc('hitsList')
                .get()
                .then((docOption) => {
                  this.setGameDataOption({ docId, game: doc.data(), option: docOption.data() });
                })
                .catch(() => {
                  alert('データの読み込みに失敗しました。しばらくしてから再度やり直してください。');
                })
                .finally(() => {
                  this.storeIsLoading(false);
                });
            } else {
              this.setGameData({ docId, data: doc.data() });
              this.storeIsLoading(false);
            }
          }
        }, () => {
          this.storeIsLoading(false);
          this.setMessage('公開されている試合データが見つかりません。');
        });
    },
    setIsLive() {
      // 更新日付を見て、ライブ配信中かどうかを判定
      const dt = new Date();
      const diff = (dt.getTime() / 1000) - this.game.updateDate.seconds;
      if (diff < 20) {
        this.isLive = true;
      } else {
        this.isLive = false;
      }
    },
  },
};
</script>

<style scoped>
#share{
  text-align: center;
}

.btn-dblue{
  color: #fff;
  background-color: #66a2cc;
  border-color: #66a2cc;
  width: 100%;
  height: 60px;
}

.btn-dgreen{
  color: #fff;
  background-color: #04B4AE;
  border-color: #04B4AE;
  width: 100%;
  height: 60px;
}

.btn-option{
  width: 100%;
  height: 60px;
}

.pa-2 {
  padding: 2px;
}

.mw-600{
  max-width: 600px;
}

.btn-middle {
  background-color: #387CA6;
  border-color: #387CA6;
}

.title-font{
  font-family: 'Orbitron', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/views/Share.vue